import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { Select } from 'ksnm-common-ui/lib/Select';

import { usePermission } from '@src/utils/hooks/usePermission';
import { settingUserRolesStore } from '@stores/settingUserRolesStore';
import type { OrganizationDto } from '@src/api';
import type { ReportGroupsDtoDefId } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';
import type { UserFilterDtoDefId } from '@stores/settingUserRolesStore';

import styles from '../SettingUserRoles.module.scss';

interface IUserSettings {
  settings: UserFilterDtoDefId;
  organizations: OrganizationDto[];
  groups: ReportGroupsDtoDefId[];
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
}

const renderName = (value) => `${value.code} - ${value.name}`;

export const UserSettings = observer(({ settings, organizations, groups, setIsDirty }: IUserSettings) => {
  const { setUserFilter } = settingUserRolesStore;

  const permissionUserDataFilter = usePermission('CmUserDataFilter');

  const onChange = useCallback(
    (value, fieldName) => {
      let filial: (string | undefined)[] = [];

      // при выборе в фильтре головной организации, добавлять фильтры по всем дочерним организациям
      if (fieldName === 'organizationFilter' && (settings?.organizationFilter || [])?.length < value.length) {
        const organization = organizations.find((item) => item.code === value.at(-1));

        if (organization?.head) {
          filial = organizations
            .filter((item) => item.parentCode && item.parentCode === organization.code)
            .map((item) => item.code);
        }
      }

      setUserFilter({ ...settings, [fieldName]: [...new Set([...value, ...filial])] });
      setIsDirty(true);
    },
    [organizations, setIsDirty, setUserFilter, settings],
  );

  return (
    <div className={styles.row}>
      <div className={styles.cell}>{`${settings.lastName ?? ''} ${settings.firstName ?? ''}`}</div>
      <div className={styles.cell}>{settings.login ?? ''}</div>
      <div className={styles.cell}>
        <Select
          items={organizations}
          size="small"
          mode="multiple"
          value={settings?.organizationFilter}
          renderName={renderName}
          renderTag={(v) => v.code}
          onChange={(v) => onChange(v, 'organizationFilter')}
          disabled={!permissionUserDataFilter.CREATE}
          className={styles.select}
        />
      </div>
      <div className={styles.cell}>
        <Select
          items={groups}
          size="small"
          mode="multiple"
          value={settings?.groupFilter}
          renderName={renderName}
          renderTag={(v) => v.id}
          onChange={(v) => onChange(v, 'groupFilter')}
          disabled={!permissionUserDataFilter.CREATE}
          className={styles.select}
        />
      </div>
    </div>
  );
});
